function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRfq16(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 16,
    height: 16,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.557,13.863l-0,-12.475l2.367,0c0.476,0 0.838,0.112 1.086,0.336c0.248,0.224 0.445,0.62 0.594,1.187c0.148,0.568 0.222,1.195 0.222,1.881c-0,0.885 -0.123,1.631 -0.368,2.238c-0.245,0.607 -0.624,0.993 -1.137,1.157c0.187,0.21 0.329,0.417 0.427,0.621c0.206,0.443 0.401,0.996 0.586,1.66l0.929,3.395l-0.889,0l-0.707,-2.595c-0.206,-0.749 -0.376,-1.322 -0.509,-1.719c-0.134,-0.397 -0.254,-0.675 -0.359,-0.834c-0.106,-0.159 -0.213,-0.27 -0.323,-0.332c-0.08,-0.04 -0.211,-0.06 -0.393,-0.06l-0.819,0l-0,5.54l-0.707,0Zm0.707,-6.969l1.518,-0c0.323,-0 0.576,-0.078 0.758,-0.234c0.182,-0.156 0.321,-0.406 0.415,-0.749c0.095,-0.343 0.142,-0.716 0.142,-1.119c0,-0.59 -0.091,-1.075 -0.275,-1.455c-0.183,-0.38 -0.473,-0.57 -0.868,-0.57l-1.69,-0l-0,4.127Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.969,13.863l0,-12.475l3.603,0l-0,1.472l-2.896,0l0,3.864l2.506,-0l-0,1.472l-2.506,-0l0,5.667l-0.707,0Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.536,12.527c0.328,0.528 0.63,0.913 0.907,1.157l-0.208,1.149c-0.383,-0.323 -0.766,-0.834 -1.147,-1.532c-0.396,0.517 -0.833,0.775 -1.311,0.775c-0.483,-0 -0.922,-0.273 -1.315,-0.817c-0.393,-0.545 -0.696,-1.311 -0.909,-2.298c-0.212,-0.987 -0.318,-2.099 -0.318,-3.335c-0,-1.231 0.106,-2.352 0.32,-3.362c0.214,-1.009 0.518,-1.778 0.912,-2.306c0.395,-0.527 0.836,-0.791 1.324,-0.791c0.493,-0 0.938,0.274 1.334,0.821c0.395,0.548 0.697,1.313 0.905,2.298c0.207,0.984 0.311,2.094 0.311,3.331c0,1.027 -0.067,1.95 -0.2,2.77c-0.134,0.82 -0.335,1.533 -0.605,2.14Zm-1.555,-2.11c0.408,0.266 0.744,0.663 1.009,1.191c0.415,-0.885 0.623,-2.215 0.623,-3.991c-0,-1.01 -0.074,-1.892 -0.221,-2.646c-0.147,-0.755 -0.362,-1.341 -0.644,-1.758c-0.283,-0.417 -0.601,-0.625 -0.953,-0.625c-0.527,-0 -0.964,0.421 -1.311,1.264c-0.347,0.842 -0.521,2.1 -0.521,3.774c0,1.622 0.172,2.867 0.515,3.735c0.344,0.868 0.783,1.302 1.317,1.302c0.253,0 0.491,-0.11 0.714,-0.332c-0.221,-0.334 -0.454,-0.573 -0.699,-0.714l0.171,-1.2Z",
    style: {
      fillRule: "nonzero"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRfq16);
export default __webpack_public_path__ + "static/media/rfq-16.c7a93045.svg";
export { ForwardRef as ReactComponent };